import { useState, useEffect } from 'react'
import { DEFAULT_LOGO_SRC, getLogoPreviewSrc } from 'utils/logo.utils'

export default function ImageUpload ({
  logo,
  onUpload,
  onReset
}) {
  const [image, setImage] = useState(getLogoPreviewSrc(logo))
  const hasCustomLogo = image !== DEFAULT_LOGO_SRC

  useEffect(() => {
    setImage(getLogoPreviewSrc(logo))
  }, [logo])

  const handleChange = e => {
    const file = e.target.files[0]
    if (file) {
      const reader = new window.FileReader()
      reader.onloadend = async () => {
        const result = reader.result
        setImage(result)
        if (onUpload) {
          const uploadedLogo = await onUpload(file, result)
          if (uploadedLogo) {
            setImage(getLogoPreviewSrc(uploadedLogo))
          }
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const handleReset = () => {
    setImage(DEFAULT_LOGO_SRC)
    if (onReset) {
      onReset()
    }
  }

  return (
    <div className='flex flex-col items-start space-y-3'>
      <div className='w-48 h-40 bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-center shadow-sm'>
        <img
          src={image}
          alt='Logo preview'
          className='max-w-full max-h-full object-contain'
        />
      </div>
      <p className='text-sm text-gray-600'>
        {hasCustomLogo ? 'Showing uploaded logo' : 'Showing default Greenamex logo'}
      </p>
      <div className='flex flex-wrap items-center gap-2'>
        <label
          htmlFor='image-upload'
          className='cursor-pointer text-sm text-white bg-gray-400 px-4 py-2 rounded hover:bg-gray-500 transition'
        >
          Upload Logo
        </label>
        {hasCustomLogo && (
          <button
            type='button'
            onClick={handleReset}
            className='text-sm text-greenPrimary bg-white border border-gray-300 px-4 py-2 rounded hover:bg-gray-100 transition'
          >
            Reset to Default
          </button>
        )}
      </div>
      <input
        id='image-upload'
        type='file'
        accept='image/*'
        onChange={handleChange}
        className='hidden'
      />
    </div>
  )
}
